function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.26 9.10641C20.37 7.7672 18.81 7.03762 17.21 7.19753L15.92 7.32745L16.6 5.80835C17.19 4.48912 16.22 3 14.77 3H14.16C13.35 3 12.57 3.32981 12 3.91946L8.35 7.68724H8.24L3.88 7.94709C2.82 8.01705 2 8.88654 2 9.94591V18.0012C2 19.1005 2.9 20 4 20H16.64C18.37 20 19.9 18.8807 20.42 17.2216L21.8 12.8242C22.19 11.575 22 10.2158 21.27 9.1264L21.26 9.10641ZM3.99 9.92593L7.29 9.73604V17.9812H3.99V9.92593ZM18.5 16.612C18.24 17.4315 17.49 17.9812 16.63 17.9812H9.29V9.56614L9.51 9.33627L13.43 5.28865C13.62 5.09877 13.88 4.97884 14.15 4.97884H14.76L13.38 8.06702C13.24 8.39683 13.27 8.76661 13.48 9.05644C13.69 9.34627 14.04 9.49618 14.39 9.4662L17.4 9.16637C18.26 9.07643 19.1 9.47619 19.59 10.1958C19.98 10.7854 20.09 11.515 19.88 12.1946L18.5 16.592V16.612Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=ThumbUp.js.map